import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { environment } from '@environments/environment'
import { Observable } from 'rxjs'
import { AuthService } from '@modules/auth-module/services/auth.service'
import { TokensInterface } from '@modules/auth-module/interfaces/tokens.interface'
import { EnvironmentsHelperService } from '@environments/core/services/environments-helper.service'

function addTokenHeader(req: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
	return req.clone({
		setHeaders: {
			Authorization: `Bearer ${token}`,
		},
	})
}

export const apiInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
	const authService: AuthService = inject<AuthService>(AuthService)

	const environmentsHelperService: EnvironmentsHelperService =
		inject<EnvironmentsHelperService>(EnvironmentsHelperService)

	const tokens: TokensInterface | null = authService.tokens
	const apiUrl: string | null = environmentsHelperService.apiUrl
	if (!apiUrl) return next(req)

	if (req.url.startsWith(environment.environmentsConfigsUrl)) return next(req)

	if (!tokens) return next(req)

	if (authService.isAuthorized) {
		if (req.url.startsWith(apiUrl)) {
			req = addTokenHeader(req, tokens.access)
		}
	}

	return next(req)
}
